module.exports = __webpack_public_path__ + "img/success-academy-marketing.a4acaf21.png";